import { i18nLocale, SUPPORTED_LANGUAGE_TAGS } from '@weavix/models/src/translate/translate';

/**
 * Checks if the given string is a supported locale.
 */
export function isLocale(locale: string | null | undefined): locale is i18nLocale {
    return !!locale && locale in SUPPORTED_LANGUAGE_TAGS;
}
